export default __webpack_public_path__ + "static/media/AlignersCurrentStlTooth.dbd6161b.png";